/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbListClassAttributesRequest {
    getFixupPrototypeFunction() { return ServiceNowCmdbListClassAttributesRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbListClassAttributesRequest>): ServiceNowCmdbListClassAttributesRequest {
        let obj = Object.assign(new ServiceNowCmdbListClassAttributesRequest(), model);
        ServiceNowCmdbListClassAttributesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbListClassAttributesRequest>): ServiceNowCmdbListClassAttributesRequest {
        if (!model) return null;
        return ServiceNowCmdbListClassAttributesRequest.newInstance(<ServiceNowCmdbListClassAttributesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbListClassAttributesRequest) {
        if (!obj) return;

        models.ServiceNowCmdbListClassAttributesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbListClassAttributesRequest): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbListClassAttributesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the Tenant that user has access to
     */
    tenant_id: string;

    /**
     * Id of the ServiceNow Account in Corestack
     */
    cmdb_account_id: string;

    /**
     * Cmdb CI Class Name
     */
    cmdb_ci_class_name: string;

}
